module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto",
    attrs: {
      "id": "gv-difesa-suolo-foto"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-title gv-color-scheme"
  }, [_vm._v("\n    Difesa Suolo: Caricamento Foto\n    "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Pannello"
    },
    on: {
      "click": _vm.hidePanel
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-wrapper gv-inverted-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-wrapper"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-body gv-inverted-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-body"
    }
  }, [_vm._c('div', {
    attrs: {
      "id": "gv-difesa-suolo-foto-div"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-session"
  }, [_vm._v("SESSIONE: " + _vm._s(_vm.session))]), _vm._v(" "), _vm._c('el-form', {
    ref: "dsf-form",
    attrs: {
      "model": _vm.dsfForm
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-upload"
  }, [_vm._c('el-form-item', [_vm._c('el-upload', {
    ref: "dsfUpload",
    attrs: {
      "action": _vm.url,
      "limit": 20,
      "drag": "",
      "file-list": _vm.dsfForm.fileList,
      "auto-upload": false,
      "on-success": _vm.onUploadSuccess,
      "on-exceed": _vm.handleExceed,
      "multiple": "",
      "list-type": "picture"
    }
  }, [_vm._c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("\n                  Trascina qui i file o seleziona per upload "), _vm._c('br'), _vm._v("\n                  Limite massimo 20 file\n                ")])])], 1)], 1)])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-button"
  }, [_vm._c('el-button', {
    staticClass: "gv-map-catalog-button",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.submitFoto
    }
  }, [_vm._v("Carica i file")]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-map-catalog-button",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Pulisci coda")]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-map-catalog-button",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.validateAll
    }
  }, [_vm._v("Valida tutto")]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-map-catalog-button-log",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.openLogPanel
    }
  }, [_vm._v("Log")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b8d6506!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DifesaSuoloFoto.vue
// module id = 862
// module chunks = 39